import useAppDispatch from '@/hooks/useAppDispatch';
import { loadChallengesReport } from '@/redux/actions/challenge';

/**
 * Downloads the challenges CSV report for a company and saves it via a
 * throwaway <a download> link — the same blob-download pattern used
 * elsewhere in the app (e.g. `Tools.tsx`'s other report buttons).
 */
export function useDownloadChallengesReport() {
  const dispatch = useAppDispatch();

  return (companyId: number, companyName: string) => {
    dispatch(loadChallengesReport(companyId))
      .unwrap()
      .then((reportData: any) => {
        const blob = new Blob([reportData], {
          type: 'text/csv;charset=utf-8;',
        });

        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute(
            'download',
            `Challenges Report(${companyName}).csv`
          );
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };
}
